import React from "react";
import { useTranslation } from "react-i18next";
import "../Styles/components/autoBillingBadge.scss";

const AutoBillingBadge = ({ collectionMode, className = "" }) => {
    const { t } = useTranslation("common");

    if (collectionMode !== "AUTOBILL") {
        return null;
    }

    return (
        <span className={`auto-billing-badge ${className}`.trim()}>
            <i className="pi pi-bolt" aria-hidden="true" />
            <span>{t("plan.auto_billing_short")}</span>
        </span>
    );
};

export default AutoBillingBadge;
